import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = {
  key: 0,
  class: "box-empty"
}
const _hoisted_3 = { class: "results" }
const _hoisted_4 = { class: "item-content" }
const _hoisted_5 = { class: "images" }
const _hoisted_6 = ["src", "alt", "onClick"]
const _hoisted_7 = { class: "actions" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 1,
  class: "upload"
}
const _hoisted_10 = { class: "form" }
const _hoisted_11 = {
  key: 0,
  class: "laboratory-group"
}
const _hoisted_12 = { class: "group-row" }
const _hoisted_13 = { class: "flex-1" }
const _hoisted_14 = ["disabled", "onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "flex-1" }
const _hoisted_17 = ["disabled", "onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "flex justify-start w-full" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "flex flex-row sm-flex-col md-flex-col gap-8 justify-center py-4 w-full" }
const _hoisted_22 = ["disabled", "onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "box-add" }

import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import debounce from "lodash-es/debounce";
import store from "@/store";

import { toast } from "@/common/utils/toast";
import { PDFtoIMG, PDFtoText } from "@/common/services/convert";

import {
  analysisResultList,
  analysisResultCreate,
  analysisResultPatch,
  analysisResultDelete,
  analysisResultResume,
} from "@/common/api/rest/analysis/result";
import { fileCreate, fileDelete } from "@/common/api/rest/file/file";
import { analysisMethodList } from "@/common/api/rest/analysis/method";
import { analysisSampleList } from "@/common/api/rest/analysis/sample";
import { evaluationLaboratoryList } from "@/common/api/rest/evaluation/laboratory";

import type { AnalysisType } from "@/common/types/analysis";
import type { ResultType } from "@/common/types/result";
import type { FileType, FieldType } from "@/common/types/common";
import type { SampleListType } from "@/common/types/sample";
import type { MethodItemType } from "@/common/types/method/method-item";
import type { LaboratoryListType } from "@/common/types/laboratory";

import { fileUploadForm, resultFieldForm, viewImage } from "@/components";
import {
  baseConfirm,
  baseDate,
  baseInput,
  baseLoading,
  baseModal,
  baseTextarea,
  baseSelect,
  svgIcon,
} from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'result',
  props: {
    data: {},
    width: { default: "100%" },
    isEdit: { type: Boolean, default: true }
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const fileExtensions = [".jpg", ".jpeg", ".pdf"];

const fileKey = ref(0);

const results = ref<ResultType[]>([]);
const fields = ref<FieldType[][]>([]);
const fieldsAi = ref<FieldType[][]>([]);
const fieldPayload = ref<FieldType | null>(null);
const loadingResult = ref<string[]>([]);
const laboratories = ref<LaboratoryListType[]>([]);

const methods = ref<MethodItemType[]>([]);
const samples = ref<SampleListType[]>([]);

const selected = ref<ResultType | null>(null);
const selectedFile = ref<string | null>(null);
const selectedImage = ref<string | null>(null);
const selectedField = ref<{
  index: number;
  field?: number;
  type: "fields" | "fields_ai";
} | null>(null);

const showDelResult = ref(false);
const showDelImage = ref(false);
const showAddField = ref(false);
const showDelField = ref(false);
const fieldEdit = ref(false);

const methodOptions = computed(() =>
  methods.value.map((item) => ({ option: item.code, value: item.method_id })),
);

const sampleOptions = computed(() =>
  samples.value.map((item) => ({ option: item.code, value: item.sample_id })),
);

const laboratoryOptions = computed(() =>
  laboratories.value.map((item) => ({
    option: item.name,
    value: item.laboratory_id,
  })),
);

const laboratoryStatusOptions = computed(() => [
  { option: "Pendente", value: "PENDING" },
  { option: "Enviado", value: "SENT" },
  { option: "Recebido", value: "RECEIVED" },
  { option: "Cancelado", value: "CANCELED" },
]);

function resumeMetadata() {
  fields.value = results.value.map((item) => item.metadata?.fields || []);
  fieldsAi.value = results.value.map((item) => item.metadata?.fields_ai || []);
}

function fecthData() {
  if (!props.data) return;

  analysisResultList(props.data.account_id, {
    analysis_id: props.data.analysis_id,
    full: true,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        results.value = data.list?.map((item) => ({
          ...item,
          metadata:
            typeof item.metadata === "string"
              ? JSON.parse(item.metadata)
              : item.metadata,
        }));
        resumeMetadata();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function fetchMethods() {
  if (!props.data) return;

  analysisMethodList(props.data.account_id, {
    analysis_id: props.data.analysis_id,
    full: true,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        methods.value = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function fetchSamples() {
  if (!props.data?.analysis_id) {
    return;
  }

  analysisSampleList(props.data.account_id, {
    analysis_id: props.data.analysis_id,
    full: true,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        samples.value = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function fetchLaboratories() {
  if (!props.data?.evaluation_id) {
    return;
  }

  evaluationLaboratoryList(props.data.account_id, {
    evaluation_id: props.data.evaluation_id,
    page: 0,
    full: true,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        laboratories.value = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function patchData(result_id: string, payload: Partial<ResultType>) {
  analysisResultPatch(props.data.account_id, result_id, payload)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fecthData();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function updateResult(index: number, key: keyof ResultType) {
  const result = results.value[index];

  patchData(result.result_id, { [key]: result[key] });
}

function updateMetadata(index: number, key: "fields" | "fields_ai") {
  const result = results.value[index];

  const data = {
    fields: fields.value,
    fields_ai: fieldsAi.value,
  };

  const metadataString = JSON.stringify({
    ...result.metadata,
    [key]: data[key][index],
  });

  patchData(result.result_id, { metadata: metadataString });
}

function addResult() {
  if (!props.data) return;

  store.commit("SET_LOADING", true);

  analysisResultCreate(props.data.account_id, {
    evaluation_id: props.data.evaluation_id,
    analysis_id: props.data.analysis_id,
  })
    .then((response) => {
      const { success, message } = response;

      fecthData();
      toast({ message: message, type: success ? "success" : "error" });
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function delResult(index: number) {
  selected.value = results.value[index];
  showDelResult.value = true;
}

function delResultCancel() {
  selected.value = null;
  showDelResult.value = false;
}

function delResultConfirm() {
  if (!selected.value) return;

  store.commit("SET_LOADING", true);
  showDelResult.value = false;

  analysisResultDelete(props.data.account_id, selected.value.result_id)
    .then((response) => {
      const { success, message } = response;

      fecthData();
      delResultCancel();
      toast({ message: message, type: success ? "success" : "error" });
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

// ADD IMAGE
async function uploadFile(index: number, fileData: FileType) {
  const { extension, name, file } = fileData;

  store.commit("SET_LOADING", true);

  const result = results.value[index];

  if (extension?.toLowerCase() === "pdf") {
    const pdfText = await PDFtoText(file);

    if (pdfText.success) {
      const texts = pdfText.pages?.map((item) => item.text).join("\n");

      const metadataString = JSON.stringify({
        ...result.metadata,
        pdf_text: texts,
      });

      patchData(result.result_id, { metadata: metadataString });
    }

    const converted = await PDFtoIMG(file);

    if (converted.success) {
      for (const item of converted.pages ?? []) {
        await fileCreate(props.data.account_id, result.result_id, {
          file: item.image.split(",")[1],
          type: "RESULT",
          name,
          extension: "jpg",
          page: item.page,
          infos: item.image.split(",")[0],
        })
          .then((response) => {
            if (!response.success) {
              toast({ message: response.message, type: "error" });
            }
          })
          .catch(() => {
            toast({ message: t("error.default"), type: "error" });
          });
      }
    } else {
      toast({ message: t("error.default"), type: "error" });
    }

    fileKey.value++;
    fecthData();
    store.commit("SET_LOADING", false);
  } else {
    fileCreate(props.data.account_id, result.result_id, {
      ...fileData,
      type: "RESULT",
    })
      .then((response) => {
        const { success, message } = response;

        if (success) {
          fecthData();
          toast({ message: message, type: "success" });
        } else {
          toast({ message: message, type: "error" });
        }
      })
      .catch(() => {
        toast({ message: t("error.default"), type: "error" });
      })
      .finally(() => {
        fileKey.value++;
        store.commit("SET_LOADING", false);
      });
  }
}

function delImage(index: number, file_id?: string) {
  if (!file_id) return;

  selected.value = results.value[index];
  selectedFile.value = file_id;
  showDelImage.value = true;
}

function delImageCancel() {
  selected.value = null;
  selectedFile.value = null;
  showDelImage.value = false;
}

function delImageConfirm() {
  if (!selected.value || !selectedFile.value) return;

  showDelImage.value = false;
  store.commit("SET_LOADING", true);

  fileDelete(props.data.account_id, selectedFile.value)
    .then((response) => {
      const { success, message } = response;

      fecthData();
      delImageCancel();
      toast({ message: message, type: success ? "success" : "error" });
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

// FIELD
function addField(index: number) {
  showAddField.value = true;
  selectedField.value = { index: index, type: "fields" };
}

function addFieldCancel() {
  selected.value = null;
  fieldPayload.value = null;
  showAddField.value = false;
  fieldEdit.value = false;
}

function addFieldConfirm() {
  if (!selectedField.value || !fieldPayload.value) return;

  if (!fields.value[selectedField.value.index])
    fields.value[selectedField.value.index] = [];

  fields.value[selectedField.value.index].push(fieldPayload.value);

  updateMetadata(selectedField.value.index, "fields");
  addFieldCancel();
}

function editField(
  index: number,
  field_index: number,
  type: "fields" | "fields_ai",
) {
  const data = {
    fields: fields.value,
    fields_ai: fieldsAi.value,
  };

  fieldEdit.value = true;
  selectedField.value = { index, field: field_index, type };
  fieldPayload.value = data[type][index][field_index];
  showAddField.value = true;
}

function editFieldConfirm() {
  if (
    !selectedField.value ||
    !fieldPayload.value ||
    selectedField.value.field === undefined
  )
    return;

  const { index, field: field_index, type } = selectedField.value;

  if (type === "fields") {
    fields.value[index][field_index] = fieldPayload.value;
  }

  if (type === "fields_ai") {
    fieldsAi.value[index][field_index] = fieldPayload.value;
  }

  updateMetadata(selectedField.value.index, type);
  addFieldCancel();
}

function submitField() {
  if (!fieldEdit.value) addFieldConfirm();
  else editFieldConfirm();
}

function delField(
  index: number,
  field_index: number,
  type: "fields" | "fields_ai",
) {
  selectedField.value = { index, field: field_index, type };
  showDelField.value = true;
}

function delFieldCancel() {
  selectedField.value = null;
  showDelField.value = false;
}

function delFieldConfirm() {
  if (!selectedField.value) return;

  const { index, field: field_index, type } = selectedField.value;

  if (type === "fields") {
    fields.value[index].splice(field_index!, 1);
  }

  if (type === "fields_ai") {
    fieldsAi.value[index].splice(field_index!, 1);
  }

  updateMetadata(selectedField.value.index, type);
  delFieldCancel();
}

async function generateResume(item: any) {
  store.commit("SET_LOADING", true);

  console.log("result", item);

  await analysisResultResume(props.data.account_id, item.result_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fecthData();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function resultLaboratoryChange(index: number) {
  patchData(results.value[index].result_id, {
    laboratory_id: results.value[index].laboratory_id,
    laboratory_description: null,
    laboratory_receive_date: null,
    laboratory_send_date: null,
    laboratory_status: null,
  });
}

const debounceUpdate = debounce(updateResult, 1000);
const debounceMetadata = debounce(updateMetadata, 1000);

onMounted(() => {
  fecthData();
  fetchMethods();
  fetchSamples();
  fetchLaboratories();
});

return (_ctx: any,_cache: any) => {
  const _component_templete = _resolveComponent("templete")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", {
      class: _normalizeClass(["tab-component", { width: __props.width }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        (results.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createTextVNode(_toDisplayString(_unref(t)("result.texts.result_empty")) + " ", 1),
              _createElementVNode("button", {
                class: "btn btn-md btn-primary uppercase",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (addResult()))
              }, _toDisplayString(_unref(t)("result.labels.add_result")), 1)
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.result_id,
                    class: "item"
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["files", {
                    'has-images': item.files,
                  }])
                      }, [
                        (item.files)
                          ? (_openBlock(), _createBlock(_component_templete, { key: 0 }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_5, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.files, (image, img_idx) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: img_idx,
                                      class: "image"
                                    }, [
                                      _createElementVNode("img", {
                                        src: image.file,
                                        alt: `image ${img_idx + 1}`,
                                        onClick: ($event: any) => (selectedImage.value = image.file)
                                      }, null, 8, _hoisted_6),
                                      _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("button", {
                                          class: "btn btn-sm btn-default",
                                          onClick: ($event: any) => (delImage(index, image.file_id))
                                        }, [
                                          _createVNode(_unref(svgIcon), {
                                            icon: "trash",
                                            size: "1.25rem"
                                          })
                                        ], 8, _hoisted_8)
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        (!item.files?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              (_openBlock(), _createBlock(_unref(fileUploadForm), {
                                key: fileKey.value,
                                extensions: fileExtensions,
                                onUpdateData: ($event: any) => (uploadFile(index, $event))
                              }, null, 8, ["onUpdateData"]))
                            ]))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_unref(baseInput), {
                          modelValue: item.name,
                          "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                          value: item.name,
                          required: "",
                          onInput: ($event: any) => (_unref(debounceUpdate)(index, 'name'))
                        }, {
                          label: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)("common.labels.name")) + " *", 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onUpdate:modelValue", "value", "onInput"]),
                        _createVNode(_unref(baseSelect), {
                          modelValue: item.method_id,
                          "onUpdate:modelValue": ($event: any) => ((item.method_id) = $event),
                          value: item.method_id,
                          options: methodOptions.value,
                          "is-empty": true,
                          onChange: ($event: any) => (_unref(debounceUpdate)(index, 'method_id'))
                        }, {
                          label: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)("common.labels.method")), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onUpdate:modelValue", "value", "options", "onChange"]),
                        _createVNode(_unref(baseSelect), {
                          modelValue: item.sample_id,
                          "onUpdate:modelValue": ($event: any) => ((item.sample_id) = $event),
                          value: item.sample_id,
                          options: sampleOptions.value,
                          "is-empty": true,
                          onChange: ($event: any) => (_unref(debounceUpdate)(index, 'sample_id'))
                        }, {
                          label: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)("common.labels.sample")), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onUpdate:modelValue", "value", "options", "onChange"]),
                        _createVNode(_unref(baseSelect), {
                          modelValue: item.laboratory_id,
                          "onUpdate:modelValue": ($event: any) => ((item.laboratory_id) = $event),
                          value: item.laboratory_id,
                          options: laboratoryOptions.value,
                          "is-empty": true,
                          onChange: ($event: any) => (resultLaboratoryChange(index))
                        }, {
                          label: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)("common.labels.laboratory")), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onUpdate:modelValue", "value", "options", "onChange"]),
                        (item.laboratory_id)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createVNode(_unref(baseSelect), {
                                modelValue: item.laboratory_status,
                                "onUpdate:modelValue": ($event: any) => ((item.laboratory_status) = $event),
                                value: item.laboratory_status,
                                options: laboratoryStatusOptions.value,
                                "is-empty": false,
                                onChange: ($event: any) => (_unref(debounceUpdate)(index, 'laboratory_status'))
                              }, {
                                label: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                  _createTextVNode(" Status do Envio para Laboratório ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["modelValue", "onUpdate:modelValue", "value", "options", "onChange"]),
                              _createElementVNode("div", _hoisted_12, [
                                _createVNode(_unref(baseDate), {
                                  modelValue: item.laboratory_send_date,
                                  "onUpdate:modelValue": [($event: any) => ((item.laboratory_send_date) = $event), ($event: any) => (
                            _unref(debounceUpdate)(index, 'laboratory_send_date')
                          )],
                                  value: item.laboratory_send_date,
                                  required: false,
                                  "value-mask": "YYYY-MM-DD",
                                  placeholder: "--/--/----"
                                }, {
                                  label: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                    _createTextVNode(" Data de envio para laboratório ", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["modelValue", "onUpdate:modelValue", "value"]),
                                _createVNode(_unref(baseDate), {
                                  modelValue: item.laboratory_receive_date,
                                  "onUpdate:modelValue": [($event: any) => ((item.laboratory_receive_date) = $event), ($event: any) => (
                            _unref(debounceUpdate)(index, 'laboratory_receive_date')
                          )],
                                  value: item.laboratory_receive_date,
                                  required: false,
                                  "value-mask": "YYYY-MM-DD",
                                  placeholder: "--/--/----"
                                }, {
                                  label: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                    _createTextVNode(" Data de recepção do laboratório ", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["modelValue", "onUpdate:modelValue", "value"])
                              ]),
                              _createVNode(_unref(baseTextarea), {
                                modelValue: item.laboratory_description,
                                "onUpdate:modelValue": ($event: any) => ((item.laboratory_description) = $event),
                                value: item.laboratory_description,
                                placeholder: _unref(t)('common.placeholders.describe'),
                                onInput: ($event: any) => (_unref(debounceUpdate)(index, 'laboratory_description'))
                              }, {
                                label: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)("common.labels.description")), 1)
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onUpdate:modelValue", "value", "placeholder", "onInput"])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_unref(baseTextarea), {
                          modelValue: item.description,
                          "onUpdate:modelValue": ($event: any) => ((item.description) = $event),
                          value: item.description,
                          placeholder: _unref(t)('common.placeholders.describe'),
                          onInput: ($event: any) => (_unref(debounceUpdate)(index, 'description'))
                        }, {
                          label: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)("common.labels.description")), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onUpdate:modelValue", "value", "placeholder", "onInput"]),
                        _createVNode(_unref(baseTextarea), {
                          modelValue: item.result,
                          "onUpdate:modelValue": ($event: any) => ((item.result) = $event),
                          value: item.result,
                          placeholder: _unref(t)('common.placeholders.describe'),
                          onInput: ($event: any) => (_unref(debounceUpdate)(index, 'result'))
                        }, {
                          label: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)("common.labels.result")), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onUpdate:modelValue", "value", "placeholder", "onInput"]),
                        (fieldsAi.value[index])
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(fieldsAi.value[index], (field, field_index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: field.field_id,
                                class: "flex flex-row gap-2 items-end w-full"
                              }, [
                                _createElementVNode("div", _hoisted_13, [
                                  (field.type === 'text')
                                    ? (_openBlock(), _createBlock(_unref(baseInput), {
                                        key: 0,
                                        modelValue: field.answer,
                                        "onUpdate:modelValue": ($event: any) => ((field.answer) = $event),
                                        value: field.answer,
                                        type: "text",
                                        onInput: ($event: any) => (_unref(debounceMetadata)(index, 'fields_ai'))
                                      }, {
                                        label: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(field.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "value", "onInput"]))
                                    : _createCommentVNode("", true),
                                  (field.type === 'number')
                                    ? (_openBlock(), _createBlock(_unref(baseInput), {
                                        key: 1,
                                        modelValue: field.answer,
                                        "onUpdate:modelValue": ($event: any) => ((field.answer) = $event),
                                        value: field.answer,
                                        type: "number",
                                        onInput: ($event: any) => (_unref(debounceMetadata)(index, 'fields_ai'))
                                      }, {
                                        label: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(field.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "value", "onInput"]))
                                    : _createCommentVNode("", true),
                                  (field.type === 'textarea')
                                    ? (_openBlock(), _createBlock(_unref(baseTextarea), {
                                        key: 2,
                                        modelValue: field.answer,
                                        "onUpdate:modelValue": ($event: any) => ((field.answer) = $event),
                                        value: field.answer,
                                        onInput: ($event: any) => (_unref(debounceMetadata)(index, 'fields_ai'))
                                      }, {
                                        label: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(field.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "value", "onInput"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("button", {
                                  class: "btn btn-default w-9 h-9 p-0 mb-1",
                                  disabled: field.type === 'range',
                                  onClick: ($event: any) => (editField(index, field_index, 'fields_ai'))
                                }, [
                                  _createVNode(_unref(svgIcon), {
                                    icon: "edit",
                                    size: "1.25rem"
                                  })
                                ], 8, _hoisted_14),
                                _createElementVNode("button", {
                                  class: "btn btn-default w-9 h-9 p-0 mb-1",
                                  onClick: ($event: any) => (delField(index, field_index, 'fields_ai'))
                                }, [
                                  _createVNode(_unref(svgIcon), {
                                    icon: "trash",
                                    size: "1.25rem"
                                  })
                                ], 8, _hoisted_15)
                              ]))
                            }), 128))
                          : _createCommentVNode("", true),
                        (fields.value[index])
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(fields.value[index], (field, field_index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: field.field_id,
                                class: "flex flex-row gap-2 items-end w-full"
                              }, [
                                _createElementVNode("div", _hoisted_16, [
                                  (field.type === 'text')
                                    ? (_openBlock(), _createBlock(_unref(baseInput), {
                                        key: 0,
                                        modelValue: field.answer,
                                        "onUpdate:modelValue": ($event: any) => ((field.answer) = $event),
                                        value: field.answer,
                                        type: "text",
                                        onInput: ($event: any) => (_unref(debounceMetadata)(index, 'fields'))
                                      }, {
                                        label: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(field.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "value", "onInput"]))
                                    : _createCommentVNode("", true),
                                  (field.type === 'number')
                                    ? (_openBlock(), _createBlock(_unref(baseInput), {
                                        key: 1,
                                        modelValue: field.answer,
                                        "onUpdate:modelValue": ($event: any) => ((field.answer) = $event),
                                        value: field.answer,
                                        type: "number",
                                        onInput: ($event: any) => (_unref(debounceMetadata)(index, 'fields'))
                                      }, {
                                        label: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(field.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "value", "onInput"]))
                                    : _createCommentVNode("", true),
                                  (field.type === 'textarea')
                                    ? (_openBlock(), _createBlock(_unref(baseTextarea), {
                                        key: 2,
                                        modelValue: field.answer,
                                        "onUpdate:modelValue": ($event: any) => ((field.answer) = $event),
                                        value: field.answer,
                                        onInput: ($event: any) => (_unref(debounceMetadata)(index, 'fields'))
                                      }, {
                                        label: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(field.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "value", "onInput"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("button", {
                                  class: "btn btn-default w-9 h-9 p-0 mb-1",
                                  disabled: field.type === 'range',
                                  onClick: ($event: any) => (editField(index, field_index, 'fields'))
                                }, [
                                  _createVNode(_unref(svgIcon), {
                                    icon: "edit",
                                    size: "1.25rem"
                                  })
                                ], 8, _hoisted_17),
                                _createElementVNode("button", {
                                  class: "btn btn-default w-9 h-9 p-0 mb-1",
                                  onClick: ($event: any) => (delField(index, field_index, 'fields'))
                                }, [
                                  _createVNode(_unref(svgIcon), {
                                    icon: "trash",
                                    size: "1.25rem"
                                  })
                                ], 8, _hoisted_18)
                              ]))
                            }), 128))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("button", {
                            class: "btn btn-md btn-default uppercase",
                            onClick: ($event: any) => (addField(index))
                          }, [
                            _createVNode(_unref(svgIcon), {
                              icon: "add",
                              size: "1.25rem"
                            }),
                            _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.field")), 1)
                          ], 8, _hoisted_20)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      (item.metadata?.pdf_text)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-md btn-default uppercase",
                            disabled: loadingResult.value.includes(item.result_id),
                            onClick: ($event: any) => (generateResume(item))
                          }, [
                            (loadingResult.value.includes(item.result_id))
                              ? (_openBlock(), _createBlock(_unref(baseLoading), {
                                  key: 0,
                                  size: "1.25rem"
                                }))
                              : _createCommentVNode("", true),
                            _cache[15] || (_cache[15] = _createTextVNode(" Extrair Resultado ", -1))
                          ], 8, _hoisted_22))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        class: "btn btn-md btn-danger uppercase",
                        onClick: ($event: any) => (delResult(index))
                      }, [
                        _createVNode(_unref(svgIcon), {
                          icon: "trash",
                          size: "1.5rem"
                        }),
                        _createTextVNode(" " + _toDisplayString(_unref(t)("result.labels.remove_result")), 1)
                      ], 8, _hoisted_23)
                    ])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("button", {
                  class: "btn btn-md btn-primary uppercase",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (addResult()))
                }, _toDisplayString(_unref(t)("result.labels.add_result")), 1)
              ])
            ], 64))
      ])
    ], 2),
    _createVNode(_unref(viewImage), {
      image: selectedImage.value,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (selectedImage.value = null))
    }, null, 8, ["image"]),
    _createVNode(_unref(baseModal), {
      width: "80%",
      show: showAddField.value,
      "show-button-confirm": true,
      title: 
      fieldEdit.value
        ? _unref(t)('result.labels.edit_field').toUpperCase()
        : _unref(t)('result.labels.add_field').toUpperCase()
    ,
      "button-confirm": _unref(t)('common.labels.confirm'),
      "button-close": _unref(t)('common.labels.cancel'),
      onConfirm: _cache[4] || (_cache[4] = ($event: any) => (submitField())),
      onClose: _cache[5] || (_cache[5] = ($event: any) => (addFieldCancel()))
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(resultFieldForm), {
          data: fieldPayload.value,
          onUpdateData: _cache[3] || (_cache[3] = ($event: any) => (fieldPayload.value = $event))
        }, null, 8, ["data"])
      ]),
      _: 1
    }, 8, ["show", "title", "button-confirm", "button-close"]),
    _createVNode(_unref(baseConfirm), {
      show: showDelResult.value,
      "max-width": "400px",
      title: _unref(t)('result.modals.titles.remove_result').toUpperCase(),
      message: _unref(t)('result.modals.messages.remove_result'),
      onCancel: _cache[6] || (_cache[6] = ($event: any) => (delResultCancel())),
      onConfirm: _cache[7] || (_cache[7] = ($event: any) => (delResultConfirm()))
    }, null, 8, ["show", "title", "message"]),
    _createVNode(_unref(baseConfirm), {
      show: showDelField.value,
      "max-width": "400px",
      title: _unref(t)('result.modals.titles.remove_field').toUpperCase(),
      message: _unref(t)('result.modals.messages.remove_field'),
      onCancel: _cache[8] || (_cache[8] = ($event: any) => (delFieldCancel())),
      onConfirm: _cache[9] || (_cache[9] = ($event: any) => (delFieldConfirm()))
    }, null, 8, ["show", "title", "message"]),
    _createVNode(_unref(baseConfirm), {
      show: showDelImage.value,
      "max-width": "400px",
      title: _unref(t)('common.modals.titles.remove_image').toUpperCase(),
      message: _unref(t)('common.modals.messages.remove_image'),
      onCancel: _cache[10] || (_cache[10] = ($event: any) => (delImageCancel())),
      onConfirm: _cache[11] || (_cache[11] = ($event: any) => (delImageConfirm()))
    }, null, 8, ["show", "title", "message"])
  ], 64))
}
}

})